import { render, staticRenderFns } from "./HomeVodCard.vue?vue&type=template&id=3ad55503&scoped=true&"
import script from "./HomeVodCard.vue?vue&type=script&lang=js&"
export * from "./HomeVodCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeVodCard.vue?vue&type=style&index=0&id=3ad55503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad55503",
  null
  
)

export default component.exports